import React, { forwardRef } from 'react'
import { Tooltip } from '@radix-ui/themes'
import styles from './toolbar.module.css'

type ToolbarButtonProps = {
  onClick?: () => void
  active?: boolean
  title: string
  ariaLabel: string
  children: React.ReactNode
} & Omit<
  React.ButtonHTMLAttributes<HTMLButtonElement>,
  'onClick' | 'title' | 'aria-label' | 'className' | 'type'
>

export const ToolbarButton = forwardRef<HTMLButtonElement, ToolbarButtonProps>(
  function ToolbarButton(
    { onClick, active, title, ariaLabel, children, ...rest },
    ref,
  ) {
    return (
      <Tooltip content={title}>
        <button
          ref={ref}
          type="button"
          className={`${styles.toolbarButton} ${
            active ? styles.toolbarButtonActive : ''
          }`}
          onClick={onClick}
          aria-label={ariaLabel}
          {...rest}
        >
          {children}
        </button>
      </Tooltip>
    )
  },
)
